var CLOSEST_DIV_URL, ClosestDivision;

CLOSEST_DIV_URL = '/layout/get_location_sort?callback=?';

module.exports = ClosestDivision = {
  getClosestDivision: function(options) {
    var error, lang, lat, lng, loc, locale, ref, success;
    if (options == null) {
      options = {};
    }
    loc = options.loc, lat = options.lat, lng = options.lng, success = options.success, error = options.error;
    lang = document.head.getAttribute('data-language');
    locale = document.head.getAttribute('data-locale');
    if ((ref = this._xhr) != null) {
      ref.abort();
    }
    this._xhr = $.getJSON(CLOSEST_DIV_URL, {
      loc: loc,
      lat: lat,
      lng: lng,
      lang: lang,
      locale: locale
    }, success);
    return this._xhr.fail(error);
  },
  abort: function() {
    var ref;
    return (ref = this._xhr) != null ? ref.abort() : void 0;
  }
};

